import React from 'react';
import {setWatchIsActive} from "../../Features/Misc/navBarSlice";

import {useDispatch} from "react-redux";

const NoFaves = () => {

    const dispatch = useDispatch();

    return (
        <div className={`grid grid-rows-12 grid-cols-24 `}>

            <div className={`row-start-3 row-end-4 col-start-3 col-end-23 grid justify-center content-center`}>
                <i className="ri-folder-open-line  justify-content-center text-unfocused-text text-6xl cursor-pointer "></i>
            </div>

            <div className={`text-white text-2xl text-unfocused-text row-start-4 row-end-5 col-start-3 col-end-23 grid justify-center content-center`}>
                <div>No favourites yet...</div>
            </div>

            <div className={`text-white  text-xl text-unfocused-text row-start-5 row-end-6 col-start-3 col-end-23 grid justify-center content-center`}>
                <div onClick={() => dispatch(setWatchIsActive())} className={` bg-gold-accent p-4 rounded-lg cursor-pointer `}>Go get some!</div>
            </div>

        </div>
    );
};

export default NoFaves;
